import { HttpMethod } from '../methods';
import { UrlConstant } from '../../Core/Interfaces/interfaces';

export const GET_DICTIONARIES: UrlConstant = { path: '/keywords', method: HttpMethod.GET };
